export const DOCTOR_CREATE_REQUEST = 'DOCTOR_CREATE_REQUEST'
export const DOCTOR_CREATE_SUCCESS = 'DOCTOR_CREATE_SUCCESS'
export const DOCTOR_CREATE_FAIL = 'DOCTOR_CREATE_FAIL'
export const DOCTOR_CREATE_RESET = 'DOCTOR_CREATE_RESET'


export const LIST_DOCTOR_REQUEST = 'LIST_DOCTOR_REQUEST'
export const LIST_DOCTOR_SUCCESS = 'LIST_DOCTOR_SUCCESS'
export const LIST_DOCTOR_FAIL = 'LIST_DOCTOR_FAIL'
export const LIST_DOCTOR_RESET = 'LIST_DOCTOR_RESET'

export const DOCTOR_DELETE_REQUEST = 'DOCTOR_DELETE_REQUEST'
export const DOCTOR_DELETE_SUCCESS = 'DOCTOR_DELETE_SUCCESS '
export const DOCTOR_DELETE_FAIL = 'DOCTOR_DELETE_FAIL'


export const LIST_GENDER_ENUMS_REQUEST = 'LIST_GENDER_ENUMS_REQUEST'
export const LIST_GENDER_ENUMS_SUCCESS = 'LIST_GENDER_ENUMS_SUCCESS'
export const LIST_GENDER_ENUMS_FAIL = 'LIST_GENDER_ENUMS_FAIL'
export const LIST_GENDER_ENUMS_RESET = 'LIST_GENDER_ENUMS_RESET'


export const LIST_DUTY_ENUMS_REQUEST = 'LIST_DUTY_ENUMS_REQUEST'
export const LIST_DUTY_ENUMS_SUCCESS = 'LIST_DUTY_ENUMS_SUCCESS'
export const LIST_DUTY_ENUMS_FAIL = 'LIST_DUTY_ENUMS_FAIL'
export const LIST_DUTY_ENUMS_RESET = 'LIST_DUTY_ENUMS_RESET'

export const LIST_DAYS_ENUMS_REQUEST = 'LIST_DAYS_ENUMS_REQUEST'
export const LIST_DAYS_ENUMS_SUCCESS = 'LIST_DAYS_ENUMS_SUCCESS'
export const LIST_DAYS_ENUMS_FAIL = 'LIST_DAYS_ENUMS_FAIL'
export const LIST_DAYS_ENUMS_RESET = 'LIST_DAYS_ENUMS_RESET'

export const UPDATE_DOCTOR_REQUEST = 'UPDATE_DOCTOR_REQUEST'
export const UPDATE_DOCTOR_SUCCESS = 'UPDATE_DOCTOR_SUCCESS'
export const UPDATE_DOCTOR_FAIL = 'UPDATE_DOCTOR_FAIL'
export const UPDATE_DOCTOR_RESET = 'UPDATE_DOCTOR_RESET'


export const DOCTOR_DETAILS_REQUEST = 'DOCTOR_DETAILS_REQUEST'
export const DOCTOR_DETAILS_SUCCESS = 'DOCTOR_DETAILS_SUCCESS'
export const DOCTOR_DETAILS_FAIL = 'DOCTOR_DETAILS_FAIL'